import OfferPage, { OfferPageInnerProps, OfferPageProps } from 'components/features/pfm/OfferPage/OfferPage'
import internal from 'components/utils/Internal'
import { isMobileSelector } from 'selectors/viewportSelectors'
import { connectShadedLoadable } from 'helpers/loadableHelpers'
import { Guards } from 'interfaces/guards'
import { offerGuard } from 'guards/offersGuards'
import { offerSelector } from 'selectors/offersSelector'
import { offerApply, offerShown } from 'actions/offersActions'
import { createSelector } from 'reselect'
import { createForgottenGuardError } from 'helpers/errorHelpers'
import { Offer } from 'interfaces/offers'
import PageLoadingOverlay from 'components/atoms/preloaders/PageLoadingOverlay'
import { StoreDispatch } from 'interfaces/component'
import { State } from 'interfaces/state'
import { connectOptionallyAdvanced, createPositiveRendererProps, OptionalRendererProps, NO_RENDER } from 'tangle-shared'
import { isEntityNotFound } from 'helpers/entityHelpers'
import ErrorPageContainer from 'components/features/pfm/ErrorPage/ErrorPageContainer'
import { NotFoundEntity } from 'interfaces/entity'

const mapStateToProps = () => createSelector(
  offerSelector,
  (offer): Offer | NotFoundEntity => {
    if (!offer) {
      throw createForgottenGuardError('OfferContainer', 'offerGuard')
    }

    return offer
  },
)

const offerGuards: Guards<OfferPageInnerProps> = [
  offerGuard,
]

const selectorFactory = (dispatch: StoreDispatch) =>
  (nextState: State, nextOwnProps: Offer | NotFoundEntity): OptionalRendererProps<OfferPageProps> => {
    const offer = nextOwnProps

    if (isEntityNotFound(offer)) {
      return NO_RENDER(<ErrorPageContainer />)
    }

    const props = createPositiveRendererProps<OfferPageProps>({
      offer,
      isWide: !isMobileSelector(nextState),

      onMount: () => dispatch(offerShown(offer)),
      onClickApply: () => dispatch(offerApply(offer)),
    })

    return props
  }


const OfferPageContainerOptional = connectOptionallyAdvanced<
  OfferPageProps, Offer | NotFoundEntity, State
>(selectorFactory)(OfferPage)

const OfferPageContainer = internal(
  connectShadedLoadable<
    Offer | NotFoundEntity,
    {},
    {},
    OfferPageInnerProps
  >(
    mapStateToProps, undefined, offerGuards, PageLoadingOverlay
  )(OfferPageContainerOptional)
)

export default OfferPageContainer
